import { FC, useCallback, ChangeEvent } from 'react';

import { FormNumberField } from 'src/components/FormNumberField/FormNumberField';
import { adminActions } from 'src/store/admin/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface WidthFieldProps {
  ratio: number;
}

export const WidthField: FC<WidthFieldProps> = ({ ratio }) => {
  const dispatch = useAppDispatch();

  const changeWidth = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        adminActions.update({
          width: e.target.value ? +e.target.value : undefined,
          height: e.target.value ? +e.target.value * ratio : undefined,
        }),
      );
    },
    [dispatch, ratio],
  );

  return (
    <FormNumberField
      name='width'
      onChange={changeWidth}
      size='medium'
      label='Размер'
      fullWidth
      dataTestId='administratorSize'
      required
      positive
      integer
      min={1}
    />
  );
};
